// ================  公共 start ======================================================================

/**
 * 根据key获取value
 * @param optionArr
 * @param key
 */
export function getValue(optionArr, key) {
  let resultVal = "";
  if (!optionArr || optionArr.length === 0) {
    return resultVal;
  }
  optionArr.map(item => {
    if (item.key === key) {
      resultVal = item.value;
    }
  });
  return resultVal;
}

/**
 * 设备的状态 1-装配中，2-空闲中，3-预约中, 4-作业中，5-待维护，6-维修中
 * @type {[{}]}
 */
export const INTLLIGENT_STATUS_CSS = [
  {
    key: 1,
    value: "#000000"
  },
  {
    key: 2,
    value: "#8BC34A"
  },
  {
    key: 3,
    value: "#1682e6"
  },
  {
    key: 4,
    value: "#11b95c"
  },
  {
    key: 5,
    value: "#e6a700"
  },
  {
    key: 6,
    value: "red"
  }
];

/**
 * 品牌状态 0-待认证，1-已认证，2:未通过,3-已停售
 * @type {[{value: string, key: string},{value: string, key: string}]}
 */
export const BRAND_STATUS_CSS = [
  {
    key: 0,
    value: "#e6a700"
  },
  {
    key: 1,
    value: "#11b95c"
  },
  {
    key: 2,
    value: "red"
  },
  {
    key: 3,
    value: "#d3d3d3"
  }
];

/**
 * 品牌状态 0-待审核，1-未上架，2:已上架,3-审核失败
 * @type {[{value: string, key: string},{value: string, key: string}]}
 */
export const PRODUCT_STATUS_CSS = [
  {
    key: 0,
    value: "#ED7B2F"
  },
  {
    key: 1,
    value: "#DCDCDC"
  },{
    key: 2,
    value: "#00A870"
  },{
    key: 3,
    value: "#E34D59"
  }
];

/**
 * 状态：0-待支付，1-支付中，2-待发货，3-待收货，4-交易成功，5-交易关闭
 * @type {[{value: string, key: number},{value: string, key: number}]}
 */
export const ORDER_STATUS_CSS = [
  {
    key: 0,
    value: "#DCDCDC"
  },
  {
    key: 1,
    value: "#e6a700"
  },
  {
    key: 2,
    value: "#ED7B2F"
  },
  {
    key: 3,
    value: "#1682e6"
  },
  {
    key: 4,
    value: "#11b95c"
  },
  {
    key: 5,
    value: "#E34D59"
  }, {
    key: 6,
    value: "#E34D59"
  },
  {
    key: 7,
    value: "#E34D59"
  }
];




/**
 * 配送类型：1-快递，2-同城配送，3-EMS，4-平邮
 * @type {[{value: string, key: number},{value: string, key: number}]}
 */
export const ORDER_POSTAGES_TYPE_CSS = [
  {
    key: 1,
    value: "#11b95c"
  },
  {
    key: 2,
    value: "#ED7B2F"
  },
  {
    key: 3,
    value: "#1682e6"
  },
  {
    key: 4,
    value: "#000000"
  }
];
/**
 * 售后状态：0-待受理，1-待买家寄回商品，2-待卖家收货，3-待卖家发货，4-待买家收货，5-退款中，6-退款失败，7-已完成，8-已作废
 * @type {[{value: string, key: number},{value: string, key: number}]}
 */
export const AFTER_SALE_STATUS_CSS = [
  {
    key: 0,
    value: "#b5d6c6"
  },{
    key: 1,
    value: "#839bef"
  },
  {
    key: 2,
    value: "#e66d16"
  },
  {
    key: 3,
    value: "#df9668"
  },
  {
    key: 4,
    value: "#607dd1"
  },
  {
    key: 5,
    value: "#3f6ae3"
  },
  {
    key: 6,
    value: "#ea0f18"
  },
  {
    key: 7,
    value: "#63d109"
  },
  {
    key: 8,
    value: "#a6a0a0"
  }
];
